import { api } from "./httpClient";

export const masterLookupService = {
  getByCategory(category) {
    return api(`/v1/master-lookup/${encodeURIComponent(category)}`).then((res) => res || []);
  },
};